import React from 'react';
import Helmet from 'react-helmet';

import Navbar from '../components/navbar/navbar';
import MainLayout from '../layouts/layout';
import Para1 from '../components/typographies/para1';
import Header1 from '../components/typographies/header1';

import Earth from '../static/images/mission/earth.png';

export default class Mission extends React.Component {
  render(){
    return (
      <MainLayout key="main-layout" noFooter>
        <Helmet>
          <title>Surebro: Our Mission</title>
          <meta name="description" content="Identify & Solve Problems using Tech to make Lives Easier" />
          <meta property="og:url" content="https://surebro.com/mission" />
          <meta property="og:title" content="Surebro: Our Mission" />
          <meta property="og:description" content="Identify & Solve Problems using Tech to make Lives Easier" />
          <meta property="og:image" content="https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png" />
        </Helmet>
        <Navbar key="navbar" active={0} />
        <div className="container-fluid Mission">
          <div className="Mission-mission">
            <Para1
                key="mission-label"
                className="text-left Mission-label"
                text="Our Mission is to"
            />
            <Header1
                key="mission-statement"
                className="text-left white"
                text="Identify & Solve Problems using Tech to make Lives Easier"
            />
          </div>
          <div className="Mission-space-wrapper">
            <img className="img Mission-space" src={Earth} />
          </div>
        </div>
        <div style={{marginBottom: '-60px'}}></div>
      </MainLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/mission.js